<nb-card class="content-view">
  <nb-card-header>
    {{ header }}
    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <ngx-view-profile [userId]="userId" (onClose)="close()"></ngx-view-profile>
  </nb-card-body>
</nb-card>
